/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The LogControllerDtoRollRandomGemSocketsLogListRollRandomGemSocketsLogData model module.
 * @module model/LogControllerDtoRollRandomGemSocketsLogListRollRandomGemSocketsLogData
 * @version 1.0
 */
class LogControllerDtoRollRandomGemSocketsLogListRollRandomGemSocketsLogData {
    /**
     * Constructs a new <code>LogControllerDtoRollRandomGemSocketsLogListRollRandomGemSocketsLogData</code>.
     * @alias module:model/LogControllerDtoRollRandomGemSocketsLogListRollRandomGemSocketsLogData
     */
    constructor() { 
        
        LogControllerDtoRollRandomGemSocketsLogListRollRandomGemSocketsLogData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>LogControllerDtoRollRandomGemSocketsLogListRollRandomGemSocketsLogData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/LogControllerDtoRollRandomGemSocketsLogListRollRandomGemSocketsLogData} obj Optional instance to populate.
     * @return {module:model/LogControllerDtoRollRandomGemSocketsLogListRollRandomGemSocketsLogData} The populated <code>LogControllerDtoRollRandomGemSocketsLogListRollRandomGemSocketsLogData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new LogControllerDtoRollRandomGemSocketsLogListRollRandomGemSocketsLogData();

            if (data.hasOwnProperty('logNo')) {
                obj['logNo'] = ApiClient.convertToType(data['logNo'], 'Number');
            }
            if (data.hasOwnProperty('transactionNo')) {
                obj['transactionNo'] = ApiClient.convertToType(data['transactionNo'], 'Number');
            }
            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('nftUid')) {
                obj['nftUid'] = ApiClient.convertToType(data['nftUid'], 'Number');
            }
            if (data.hasOwnProperty('gemSockets')) {
                obj['gemSockets'] = ApiClient.convertToType(data['gemSockets'], 'String');
            }
            if (data.hasOwnProperty('beforeSocketColors')) {
                obj['beforeSocketColors'] = ApiClient.convertToType(data['beforeSocketColors'], 'String');
            }
            if (data.hasOwnProperty('afterSocketColors')) {
                obj['afterSocketColors'] = ApiClient.convertToType(data['afterSocketColors'], 'String');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>LogControllerDtoRollRandomGemSocketsLogListRollRandomGemSocketsLogData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>LogControllerDtoRollRandomGemSocketsLogListRollRandomGemSocketsLogData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }
        // ensure the json data is a string
        if (data['gemSockets'] && !(typeof data['gemSockets'] === 'string' || data['gemSockets'] instanceof String)) {
            throw new Error("Expected the field `gemSockets` to be a primitive type in the JSON string but got " + data['gemSockets']);
        }
        // ensure the json data is a string
        if (data['beforeSocketColors'] && !(typeof data['beforeSocketColors'] === 'string' || data['beforeSocketColors'] instanceof String)) {
            throw new Error("Expected the field `beforeSocketColors` to be a primitive type in the JSON string but got " + data['beforeSocketColors']);
        }
        // ensure the json data is a string
        if (data['afterSocketColors'] && !(typeof data['afterSocketColors'] === 'string' || data['afterSocketColors'] instanceof String)) {
            throw new Error("Expected the field `afterSocketColors` to be a primitive type in the JSON string but got " + data['afterSocketColors']);
        }

        return true;
    }


}



/**
 * @member {Number} logNo
 */
LogControllerDtoRollRandomGemSocketsLogListRollRandomGemSocketsLogData.prototype['logNo'] = undefined;

/**
 * @member {Number} transactionNo
 */
LogControllerDtoRollRandomGemSocketsLogListRollRandomGemSocketsLogData.prototype['transactionNo'] = undefined;

/**
 * @member {Number} accountNo
 */
LogControllerDtoRollRandomGemSocketsLogListRollRandomGemSocketsLogData.prototype['accountNo'] = undefined;

/**
 * @member {String} email
 */
LogControllerDtoRollRandomGemSocketsLogListRollRandomGemSocketsLogData.prototype['email'] = undefined;

/**
 * @member {Number} nftUid
 */
LogControllerDtoRollRandomGemSocketsLogListRollRandomGemSocketsLogData.prototype['nftUid'] = undefined;

/**
 * @member {String} gemSockets
 */
LogControllerDtoRollRandomGemSocketsLogListRollRandomGemSocketsLogData.prototype['gemSockets'] = undefined;

/**
 * @member {String} beforeSocketColors
 */
LogControllerDtoRollRandomGemSocketsLogListRollRandomGemSocketsLogData.prototype['beforeSocketColors'] = undefined;

/**
 * @member {String} afterSocketColors
 */
LogControllerDtoRollRandomGemSocketsLogListRollRandomGemSocketsLogData.prototype['afterSocketColors'] = undefined;

/**
 * @member {Date} createdAt
 */
LogControllerDtoRollRandomGemSocketsLogListRollRandomGemSocketsLogData.prototype['createdAt'] = undefined;






export default LogControllerDtoRollRandomGemSocketsLogListRollRandomGemSocketsLogData;

